import { Language } from '@/utils/language';
import { EditorialContent } from './EditorialContent';

export type MultimediaType = 'ottvideo' | 'audio' | 'stream';

export type MultimediaContent = {
  id: string;
  type: 'ottvideo' | 'audio' | 'stream';
  title: string;
  slug: string;
  language: Language;
  cover: any;
  updatedAt: string;
};

export function isMultimediaContent(content: EditorialContent): content is MultimediaContent {
  return (
    'type' in content &&
    (content.type === 'ottvideo' || content.type === 'audio' || content.type === 'stream')
  );
}